import { login } from "@/api/login";
import { useMutation } from "@tanstack/react-query";
import { Button, Form, Input, message } from "antd";
import { useRouter } from "next/router";

export default function LoginScreen() {
  const router = useRouter();
  const { mutate, isPending } = useMutation({
    mutationFn: login,
    onSuccess(data, variables, context) {
      if (!data.data) {
        message.error(data.data.message || "Đăng nhập thất bại");
        return;
      }

      localStorage.setItem("token", data.data.result.token);
      router.push("/category");
      document.cookie = `token=${data.data.result.token}; path=/; max-age=864000`;
    },
  });
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4">Đăng nhập</h1>
        <Form layout="vertical" onFinish={mutate}>
          <Form.Item
            name="username"
            label="Username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input placeholder="Username" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Password" type="password" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="w-full"
              loading={isPending}
            >
              Đăng nhập
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
